import { render } from "./TicketsVue.vue?vue&type=template&id=c76f68a0"
import script from "./TicketsVue.vue?vue&type=script&lang=js"
export * from "./TicketsVue.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__